// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.col-md-3.offense {
  width: 100%;
  margin-left: 0px;
}

.col-md-2.defense {
  width: 100%;
}

.col-md-3.training {
  margin: 0px;
  width: 100%;
}

.col-md-4.works {
  width: 100%;
  margin: 0px;
  text-align: center;
}

button.buttonsActiveStyles {
  padding: 10px;
  padding-left: 10px !important;
  padding-right: 10px !important;
  border-radius: 10px;
  font-size: 0.9em;
  box-shadow: inset 0 0 20px grey;
  background-color: #c4481f !important;
  color: white;
  width: 90%;
}

button.buttonsStyles {
  padding: 10px;
  padding-left: 10px !important;
  padding-right: 10px !important;
  border-radius: 10px;
  font-size: 0.9em;
  box-shadow: inset 0 0 20px grey;
  background-color: silver !important;
  width: 90%;
  color: black;
}

.col-md-12.checkboxColumn {
  text-align: center;
  width: 100%;
  color: white;
  padding: 15px;
  padding-bottom: 0px;
}

p.tvPostCastText {
  margin-top: 0px;
  color: white;
  font-style: italic;
}

ej-checkbox.e-checkbox-wrapper {
  padding-right: 5px;
}

.e-checkbox-wrapper .e-frame,
.e-css.e-checkbox-wrapper .e-frame {
  background-color: black;
  border-color: #757575;
}

.e-checkbox-wrapper .e-checkbox:focus + .e-frame,
.e-css.e-checkbox-wrapper .e-checkbox:focus + .e-frame {
  background-color: black;
  border-color: #757575;
  box-shadow: none;
}

.sample-modal-page {
  padding: 30px;
  height: 450px;
}

.modal-wrapper {
  margin-top: 50px !important;
}

input.ng-pristine.ng-valid.ng-touched.texboxStyle {
  box-shadow: inset 0 0 20px grey;
  width: 90%;
}

::-webkit-input-placeholder {
  text-align: center;
}

:-moz-placeholder {
  /* Firefox 18- */
  text-align: center;
}

::-moz-placeholder {
  /* Firefox 19+ */
  text-align: center;
}

:-ms-input-placeholder {
  text-align: center;
}

button.parent-buy-btn.button.button-md.button-default.button-default-md:hover {
  opacity: 0.7 !important;
}

@media only screen and (max-width: 450px) {
  .sample-modal-page {
    height: 240px;
  }
  button.buttonsActiveStyles {
    padding: 10px;
    padding-left: 10px !important;
    padding-right: 10px !important;
    border-radius: 10px;
    font-size: 0.7em;
    box-shadow: inset 0 0 20px grey;
    background-color: #c4481f !important;
    color: white;
    width: 100%;
  }
  button.buttonsStyles {
    padding: 10px;
    padding-left: 10px !important;
    padding-right: 10px !important;
    border-radius: 10px;
    font-size: 0.7em;
    box-shadow: inset 0 0 20px grey;
    background-color: silver !important;
    width: 100%;
    color: black;
  }
}
.buttonsActiveStyles {
  padding: 10px;
  padding-left: 10px !important;
  padding-right: 10px !important;
  border-radius: 10px;
  font-size: 0.7em;
  box-shadow: inset 0 0 20px grey;
  background-color: #c4481f !important;
  color: white;
  width: 100%;
}

.buttonsStyles {
  padding: 10px;
  padding-left: 10px !important;
  padding-right: 10px !important;
  border-radius: 10px;
  font-size: 0.7em;
  box-shadow: inset 0 0 20px grey;
  background-color: silver !important;
  width: 100%;
  color: black;
}

.modal-wrapper {
  background-color: #353535 !important;
  height: 20%;
}

.modal {
  background-color: #353535 !important;
  border-radius: 3px;
}

.header {
  color: red;
}

.content-md {
  color: #000;
  background-color: transparent !important;
}

.header p {
  margin: 0px;
}

.close-btn {
  float: right;
  background: transparent;
  color: red;
  font-size: 17px;
}

.row input,
textarea {
  padding: 6px 12px;
  font-size: 14px;
  color: #555;
  background-color: #fff;
  border: 1px solid #E0E0E0;
  border-radius: 4px;
  width: 90%;
}

.parent-buy-btn {
  background: #BE1E2D !important;
  width: 75%;
  height: 43px !important;
  margin-left: 35px;
  margin-right: 35px;
}

.modal-wrapper {
  height: 30%;
}
.modal-wrapper .scroll-content {
  overflow: hidden;
}

.stripe-modal .modal-wrapper {
  box-shadow: 0 28px 48px rgba(0, 0, 0, 0);
  height: 250px;
}
.stripe-modal .modal-wrapper .scroll-content {
  overflow: hidden;
}

ion-content::part(scroll) {
  overflow-y: hidden;
}`, "",{"version":3,"sources":["webpack://./src/app/category-model/category-model.page.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,gBAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,WAAA;EACA,WAAA;AACJ;;AAEA;EACI,WAAA;EACA,WAAA;EACA,kBAAA;AACJ;;AAEA;EACI,aAAA;EACA,6BAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EAGA,+BAAA;EACA,oCAAA;EACA,YAAA;EACA,UAAA;AACJ;;AAGA;EACI,aAAA;EACA,6BAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EAGA,+BAAA;EACA,mCAAA;EACA,UAAA;EACA,YAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,eAAA;EACA,YAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,kBAAA;AAAJ;;AAGA;;EAEI,uBAAA;EACA,qBAAA;AAAJ;;AAGA;;EAEI,uBAAA;EACA,qBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,aAAA;AAAJ;;AAGA;EACI,2BAAA;AAAJ;;AAGA;EAGI,+BAAA;EACA,UAAA;AAAJ;;AAGA;EACI,kBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,kBAAA;AAAJ;;AAGA;EACI,uBAAA;AAAJ;;AAGA;EACI;IACI,aAAA;EAAN;EAIE;IACI,aAAA;IACA,6BAAA;IACA,8BAAA;IACA,mBAAA;IACA,gBAAA;IAGA,+BAAA;IACA,oCAAA;IACA,YAAA;IACA,WAAA;EAFN;EAME;IACI,aAAA;IACA,6BAAA;IACA,8BAAA;IACA,mBAAA;IACA,gBAAA;IAGA,+BAAA;IACA,mCAAA;IACA,WAAA;IACA,YAAA;EAJN;AACF;AAQA;EACI,aAAA;EACA,6BAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EAGA,+BAAA;EACA,oCAAA;EACA,YAAA;EACA,WAAA;AANJ;;AAUA;EACI,aAAA;EACA,6BAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EAGA,+BAAA;EACA,mCAAA;EACA,WAAA;EACA,YAAA;AAPJ;;AAWA;EACI,oCAAA;EACA,WAAA;AARJ;;AAWA;EACI,oCAAA;EACA,kBAAA;AARJ;;AAWA;EACI,UAAA;AARJ;;AAWA;EACI,WAAA;EACA,wCAAA;AARJ;;AAWA;EACI,WAAA;AARJ;;AAWA;EACI,YAAA;EACA,uBAAA;EACA,UAAA;EACA,eAAA;AARJ;;AAWA;;EAEI,iBAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;AARJ;;AAWA;EACI,8BAAA;EACA,UAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;AARJ;;AAWA;EACI,WAAA;AARJ;AAUI;EACI,gBAAA;AARR;;AAaA;EACI,wCAAA;EACA,aAAA;AAVJ;AAYI;EACI,gBAAA;AAVR;;AAcA;EACI,kBAAA;AAXJ","sourcesContent":[".col-md-3.offense {\n    width: 100%;\n    margin-left: 0px;\n}\n\n.col-md-2.defense {\n    width: 100%;\n}\n\n.col-md-3.training {\n    margin: 0px;\n    width: 100%;\n}\n\n.col-md-4.works {\n    width: 100%;\n    margin: 0px;\n    text-align: center;\n}\n\nbutton.buttonsActiveStyles {\n    padding: 10px;\n    padding-left: 10px !important;\n    padding-right: 10px !important;\n    border-radius: 10px;\n    font-size: 0.9em;\n    -webkit-box-shadow: inset 0 0 20px grey;\n    -moz-box-shadow: inset 0 0 20px grey;\n    box-shadow: inset 0 0 20px grey;\n    background-color: #c4481f !important;\n    color: white;\n    width: 90%;\n\n}\n\nbutton.buttonsStyles {\n    padding: 10px;\n    padding-left: 10px !important;\n    padding-right: 10px !important;\n    border-radius: 10px;\n    font-size: 0.9em;\n    -webkit-box-shadow: inset 0 0 20px grey;\n    -moz-box-shadow: inset 0 0 20px grey;\n    box-shadow: inset 0 0 20px grey;\n    background-color: silver !important;\n    width: 90%;\n    color: black;\n}\n\n.col-md-12.checkboxColumn {\n    text-align: center;\n    width: 100%;\n    color: white;\n    padding: 15px;\n    padding-bottom: 0px;\n}\n\np.tvPostCastText {\n    margin-top: 0px;\n    color: white;\n    font-style: italic;\n}\n\nej-checkbox.e-checkbox-wrapper {\n    padding-right: 5px;\n}\n\n.e-checkbox-wrapper .e-frame,\n.e-css.e-checkbox-wrapper .e-frame {\n    background-color: black;\n    border-color: #757575;\n}\n\n.e-checkbox-wrapper .e-checkbox:focus+.e-frame,\n.e-css.e-checkbox-wrapper .e-checkbox:focus+.e-frame {\n    background-color: black;\n    border-color: #757575;\n    box-shadow: none;\n}\n\n.sample-modal-page {\n    padding: 30px;\n    height: 450px;\n}\n\n.modal-wrapper {\n    margin-top: 50px !important;\n}\n\ninput.ng-pristine.ng-valid.ng-touched.texboxStyle {\n    -webkit-box-shadow: inset 0 0 20px grey;\n    -moz-box-shadow: inset 0 0 20px grey;\n    box-shadow: inset 0 0 20px grey;\n    width: 90%;\n}\n\n::-webkit-input-placeholder {\n    text-align: center;\n}\n\n:-moz-placeholder {\n    /* Firefox 18- */\n    text-align: center;\n}\n\n::-moz-placeholder {\n    /* Firefox 19+ */\n    text-align: center;\n}\n\n:-ms-input-placeholder {\n    text-align: center;\n}\n\nbutton.parent-buy-btn.button.button-md.button-default.button-default-md:hover {\n    opacity: 0.7 !important;\n}\n\n@media only screen and (max-width : 450px) {\n    .sample-modal-page {\n        height: 240px;\n    }\n\n\n    button.buttonsActiveStyles {\n        padding: 10px;\n        padding-left: 10px !important;\n        padding-right: 10px !important;\n        border-radius: 10px;\n        font-size: 0.7em;\n        -webkit-box-shadow: inset 0 0 20px grey;\n        -moz-box-shadow: inset 0 0 20px grey;\n        box-shadow: inset 0 0 20px grey;\n        background-color: #c4481f !important;\n        color: white;\n        width: 100%;\n\n    }\n\n    button.buttonsStyles {\n        padding: 10px;\n        padding-left: 10px !important;\n        padding-right: 10px !important;\n        border-radius: 10px;\n        font-size: 0.7em;\n        -webkit-box-shadow: inset 0 0 20px grey;\n        -moz-box-shadow: inset 0 0 20px grey;\n        box-shadow: inset 0 0 20px grey;\n        background-color: silver !important;\n        width: 100%;\n        color: black;\n    }\n}\n\n\n.buttonsActiveStyles {\n    padding: 10px;\n    padding-left: 10px !important;\n    padding-right: 10px !important;\n    border-radius: 10px;\n    font-size: 0.7em;\n    -webkit-box-shadow: inset 0 0 20px grey;\n    -moz-box-shadow: inset 0 0 20px grey;\n    box-shadow: inset 0 0 20px grey;\n    background-color: #c4481f !important;\n    color: white;\n    width: 100%;\n\n}\n\n.buttonsStyles {\n    padding: 10px;\n    padding-left: 10px !important;\n    padding-right: 10px !important;\n    border-radius: 10px;\n    font-size: 0.7em;\n    -webkit-box-shadow: inset 0 0 20px grey;\n    -moz-box-shadow: inset 0 0 20px grey;\n    box-shadow: inset 0 0 20px grey;\n    background-color: silver !important;\n    width: 100%;\n    color: black;\n}\n\n\n.modal-wrapper {\n    background-color: #353535 !important;\n    height: 20%;\n}\n\n.modal {\n    background-color: #353535 !important;\n    border-radius: 3px;\n}\n\n.header {\n    color: red;\n}\n\n.content-md {\n    color: #000;\n    background-color: transparent !important;\n}\n\n.header p {\n    margin: 0px;\n}\n\n.close-btn {\n    float: right;\n    background: transparent;\n    color: red;\n    font-size: 17px;\n}\n\n.row input,\ntextarea {\n    padding: 6px 12px;\n    font-size: 14px;\n    color: #555;\n    background-color: #fff;\n    border: 1px solid #E0E0E0;\n    border-radius: 4px;\n    width: 90%;\n}\n\n.parent-buy-btn {\n    background: #BE1E2D !important;\n    width: 75%;\n    height: 43px !important;\n    margin-left: 35px;\n    margin-right: 35px;\n}\n\n.modal-wrapper {\n    height: 30%;\n\n    .scroll-content {\n        overflow: hidden;\n    }\n}\n\n\n.stripe-modal .modal-wrapper {\n    box-shadow: 0 28px 48px rgba(0, 0, 0, 0);\n    height: 250px;\n\n    .scroll-content {\n        overflow: hidden;\n    }\n}\n\nion-content::part(scroll) {\n    overflow-y: hidden;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
